<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
      <el-button-group class="float-right">

        <el-button :disabled="lo" type="danger" v-if="Yetki" size="small" class="YeniBtn"
                   @click="EmanetKontrol">
          Emanet Kontrol
        </el-button>
        <el-button type="primary" v-if="this.$store.getters.Yetki.iletisim>0" size="small" class="YeniBtn"
                   @click="SmsGonder">
          Sms Gönder
        </el-button>
        <router-link v-if="this.$store.getters.Yetki.vezne>0"
                     class="el-button YeniBtn el-button--success el-button--small" :to="'/vezne/tahsilat/'+Kisi_id">
          Tahsilat Ekranı
        </router-link>
        <router-link class="el-button YeniBtn el-button--warning el-button--small"
                     :to="'/yonetim/mesken/'+Bilgi.Mesken_id">
          Mesken Ekranı
        </router-link>
        <el-button type="info" size="small" v-if="Yetki" class="YeniBtn" @click="DuzenleBtn">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="20" style="position:relative">
          <div class="DonemSelect" v-if="Donemler">
            <el-select v-model="DonemSecim" @change="DonemSecildi" placeholder="Dönem Seçimi" size="mini" filterable clearable>
              <el-option
                v-for="item in Donemler"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-tabs>
            <el-tab-pane :lazy=true>
              <span slot="label"><i class="el-icon-s-unfold"></i> Hesap Ekstresi</span>
              <KisiEkstre v-if="dSayfaYenile" :Donem="this.DonemSecim" :Kisi_id="Kisi_id"></KisiEkstre>
            </el-tab-pane>
            <el-tab-pane :lazy=true>
              <span slot="label"><i class="el-icon-s-marketing"></i> Özet Ekran</span>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-tabs type="border-card" class="tabs-center tab-p0">
                    <el-tab-pane label="Emanet" :lazy=true>
                      <KisiEmanet v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiEmanet>
                    </el-tab-pane>
                    <el-tab-pane v-if="Kisi_id" label="Kalorimetre Sayaç" :lazy=true>
                      <KisiKalSayac :Mesken_id="Mesken_id"></KisiKalSayac>
                    </el-tab-pane>
                    <el-tab-pane label="Sayaç Kayıtları" :lazy=true>
                      <KisiSayac v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiSayac>
                    </el-tab-pane>
                    <el-tab-pane label="İcralar" :lazy=true>
                      <KisiIcra v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiIcra>
                    </el-tab-pane>
                    <el-tab-pane v-if="Kisi_id" label="Banka" :lazy=true>
                      <KisiBanka :Kisi_id="Kisi_id"></KisiBanka>
                    </el-tab-pane>
                    <!--el-tab-pane label="İnternet" :disabled="!this.$store.getters.Uruns.Mbs[10]" :lazy=true>
                      <MeskenInternet :Mesken_id="Bilgi.Mesken_id"
                                      v-if="Bilgi && this.$store.getters.Uruns.Mbs[10]"></MeskenInternet>
                    </el-tab-pane-->
                  </el-tabs>
                </el-col>
                <el-col :span="12">
                  <el-tabs type="border-card" class=" tab-p0">
                    <el-tab-pane label="İletişim Geçmişi" :lazy=true>
                      <KisiIletisim v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiIletisim>
                    </el-tab-pane>
                    <el-tab-pane label="Santral Kayıtları" :lazy=true>
                      <KisiSantral v-if="Kisi_id" :Telefon="Bilgi.Telefon" :Kisi_id="Kisi_id"></KisiSantral>
                    </el-tab-pane>
                    <el-tab-pane label="Destek Merkezi" :lazy=true>
                      <BinaDestek v-if="Kisi_id" :Bina_id="Bilgi.Bina_id" :Kisi_id="Kisi_id"></BinaDestek>
                    </el-tab-pane>
                    <el-tab-pane label="İndirim Bilgi" :lazy=true>
                      <KisiIndirim v-if="Kisi_id" :Aktif="Bilgi.IndirimOlayi" :data="Bilgi.IndirimListe"></KisiIndirim>
                    </el-tab-pane>
                    <el-tab-pane label="Araç Kayıtları" disabled :lazy=true>
                      <KisiArac v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiArac>
                    </el-tab-pane>
                    <el-tab-pane label="İlgili Kayıtları" disabled :lazy=true>
                      <KisiAile v-if="Kisi_id" :Kisi_id="Kisi_id"></KisiAile>
                    </el-tab-pane>

                  </el-tabs>
                </el-col>
              </el-row>
            </el-tab-pane>

          </el-tabs>
        </el-col>
        <el-col :span="4">
          <div class="BlokSabit scrollkaydir" :style="'height:'+Height+'px'">
            <div class="BlokSabitKutu">
              <BilgiKutu :data="BilgiKutu" v-if="BilgiKutu"></BilgiKutu>
              <BilgiKutu :data="BilgiKutu2" v-if="BilgiKutu2"></BilgiKutu>
              <BilgiKutu :data="BilgiKutu3" v-if="BilgiKutu3"></BilgiKutu>
              <Notlar :data="Notlar"></Notlar>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <FormModal v-if="ModalOlayi" :data="Bilgi" :ModalOlayi="ModalOlayi" :Mesken="null"
               @ModalOlayi="SayfaYukle"></FormModal>
  </div>
</template>

<script>
import Notlar from "../../../components/Pack/Genel/Notlar";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
import FormModal from "../../../components/Pack/Yonetim/kisi/FormModal";
import KisiEkstre from "../../../components/Pack/Yonetim/kisi/KisiEkstre";
import KisiSayac from "../../../components/Pack/Yonetim/kisi/Ekran/KisiSayac";
import KisiSantral from "../../../components/Pack/Yonetim/kisi/Ekran/KisiSantral";
import KisiAile from "../../../components/Pack/Yonetim/kisi/Ekran/KisiAile";
import KisiArac from "../../../components/Pack/Yonetim/kisi/Ekran/KisiArac";
import KisiEmanet from "../../../components/Pack/Yonetim/kisi/Ekran/KisiEmanet";
import KisiIletisim from "../../../components/Pack/Yonetim/kisi/Ekran/KisiIletisim";
import KisiIcra from "../../../components/Pack/Yonetim/kisi/Ekran/KisiIcra";
import KisiIndirim from "../../../components/Pack/Yonetim/kisi/Ekran/KisiIndirim";
import BinaDestek from "../../../components/Pack/Yonetim/bina/Tab/BinaDestek";
import MeskenInternet from "../../../components/Pack/Internet/MeskenInternet";
import KisiKalSayac from "../../../components/Pack/Yonetim/kisi/Ekran/KisiKalSayac";
import KisiBanka from "../../../components/Pack/Yonetim/kisi/Ekran/KisiBanka";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {
    Yukleniyor,
    KisiBanka,
    KisiKalSayac,
    MeskenInternet,
    BinaDestek,
    KisiIndirim,
    KisiIcra,
    KisiIletisim,
    KisiEmanet,
    KisiArac,
    KisiAile, KisiSantral, KisiSayac, KisiEkstre, FormModal, BilgiKutu, Notlar
  },
  props: ["Kisi_id"],
  data() {
    return {
      Height: window.innerHeight - 150,
      lo: false,
      ModalOlayi: false,
      dSayfaYenile: true,
      SayfaAdi: 'Kişi Detay',
      BilgiKutu: null,
      BilgiKutu2: null,
      BilgiKutu3: null,
      Bilgi: null,
      Baslik: null,
      Yetki: false,
      SeciliBina: null,
      Mesken_id: null,
      Notlar: {
        Modul: 'Kisi',
        Modul_id: this.Kisi_id
      },
      DonemSecim: null,
      Donemler: null
    }
  },
  methods: {
    EmanetKontrol() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'yonetim/kisi/emanet/' + this.Kisi_id})
        .then(response => {
          this.lo = false
          if (response.Emanet) {
            this.$message.info(response.Emanet + ' Nolu Makbuz Emaneti çalıştı.');
            this.fSayfaYenile()
          } else {
            this.$message.info('Emanet / Tahakkuk tarihi gelmiş işlem bulunamadı.');
          }
        })
    },
    fSayfaYenile() {
      this.dSayfaYenile = false;
      setTimeout(() => {
        this.dSayfaYenile = true;
      }, 100);
    },
    SmsGonder() {
      var Value = 'Sayın ' + this.Bilgi.AdSoyad + ', ';
      var Text = 'Telefon: ' + this.Bilgi.Telefon;
      this.$prompt(Text, 'Sms Metnini Onaylayınız', {
        confirmButtonText: 'Sms Gönder',
        cancelButtonText: 'Vazgeç',
        inputType: 'textarea',
        inputValue: Value,
      }).then(({value}) => {
        if (!value) {
          this.$message.error('Sms İçeriği boş olduğu için gönderilemedi');
        } else {
          this.SmsIlet(value);
          this.$message.info('Sms gönderiliyor');
        }

      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    SmsIlet(mesaj) {
      this.Sms = [{
        Telefon: this.Bilgi.Telefon,
        Icerik: mesaj,
        Kisi_id: this.Bilgi.Kisi_id,
        Bina_id: this.Bilgi.Bina_id,
        Mesken_id: this.Bilgi.Mesken_id
      }];
      this.$store.dispatch("Post", {
        ...this.Sms,
        path: 'iletisim/sms/gonder'
      })
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        })

    },
    DuzenleBtn() {
      //this.Bilgi.Baslik = Bilgi.AdSoyad + ' Düzenle';
      this.ModalOlayi = true;
    },
    SayfaYukle() {
      this.lo = true
      this.ModalOlayi = false;
      this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/k/' + this.Kisi_id})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.Bilgi = response.Liste;
            this.Donemler = this.Bilgi.Donemler;
            this.DonemSecim = this.Bilgi.DonemSecim;
            this.Bilgi.Baslik = this.Bilgi.AdSoyad + ' Düzenle';
            this.SayfaAdi = this.Bilgi.AdSoyad;
            this.Mesken_id = this.Bilgi.Mesken_id;
            this.BilgiKutu = {
              Baslik: 'Kişi Bilgi',
              Detay: [
                {Baslik: 'Ad Soyad', Bilgi: this.Bilgi.AdSoyad},
                {Baslik: 'Telefon', Bilgi: '(' + this.Bilgi.aKodu + ') ' + this.Bilgi.Telefon},
                {Baslik: (this.Bilgi.Dogrulama === '1' ? '✅' : '⛔️') + ' TC Kimlik', Bilgi: this.Bilgi.vNo},
                {Baslik: 'Mülk', Bilgi: this.Bilgi.SahipText},
                {Baslik: 'Doğum Tarihi', Bilgi: this.Bilgi.dTarihiText},
                {Baslik: 'Giriş Tarihi', Bilgi: this.Bilgi.gTarihiText},
                {Baslik: 'Çıkış Tarihi', Bilgi: this.Bilgi.cTarihiText},
                // {
                //   Baslik: (this.Bilgi.KVKK.IP ? '✅' : '⛔️') + ' KVKK ' + this.Bilgi.KVKK.IP,
                //   Bilgi: this.Bilgi.KVKK.Tarih
                // },
              ]
            };

            this.BilgiKutu2 = {
              Baslik: 'Mesken Bilgi',
              Detay: [
                {Baslik: 'Bina', Bilgi: this.Bilgi.Adi},
                {Baslik: 'Kat / Mesken No', Bilgi: this.Bilgi.Kat + ' Kat ' + this.Bilgi.kNo + ' No.'},
              ]
            }
            if (this.Bilgi.Bilgi) {
              this.BilgiKutu3 = {
                Baslik: 'Kişi Bilgi',
                Detay: this.Bilgi.BilgiText
              }
            }
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.muhasebe == '2' ? true : false;
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
    }
    this.Ekstre = {
      Bina_id: this.SeciliBina,
      Cari_id: this.Kisi_id
    };
  },
  computed: {
    SayfaYenile() {
      return this.Kisi_id
    },
  },
  watch: {
    SayfaYenile() {
      var oKisi = this.Kisi_id;
      this.Kisi_id = null;
      this.Kisi_id = oKisi;
      this.SayfaYukle();
    },
  }

}
</script>

<style scoped>
.DonemSelect {
  position: absolute;
  right: 13px;
  top: -5px;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/kisi/Detay.vue